import script from "./PromotionalBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionalBanner.vue?vue&type=script&setup=true&lang=js"

import "./PromotionalBanner.vue?vue&type=style&index=0&id=c216faba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c216faba"]])

export default __exports__